import { render, staticRenderFns } from "./merge-shops-edit-tab.vue?vue&type=template&id=6055cc36&scoped=true"
import script from "./merge-shops-edit-tab.vue?vue&type=script&lang=js"
export * from "./merge-shops-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./merge-shops-edit-tab.vue?vue&type=style&index=0&id=6055cc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055cc36",
  null
  
)

export default component.exports